import React from "react";
import { CommonTableUI } from "../../TableTemplate/common";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { OrderErrorTableReport } from "../../../Interfaces/orderInterfaces";

const ErrorsTableUI: React.FC<ITableUI<OrderErrorTableReport>> = ({
  reports,
  onAction,
  tableBoxClassName,
  refreshFlag,
}: ITableUI<OrderErrorTableReport>) => {
  const displayedReports = {
    ...reports,
    report: reports.report.map((row) =>
      row.errorCode === "حجم کنارگذاشته‌شده در ویرایش"
        ? { ...row, messageClassname: "!whitespace-pre-line !break-words !text-right !min-w-[28rem] !max-w-[40rem]" }
        : row,
    ),
  };
  return (
    <CommonTableUI
      reports={displayedReports}
      onAction={onAction}
      tableBoxClassName={`max-h-[500px] overflow-auto ${tableBoxClassName}`}
      refreshFlag={refreshFlag}
    />
  );
};

export default ErrorsTableUI;
